import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const PartSearchField = ({ value, onChange }: Props) => {
  const { t } = useTranslation('parts');

  return (
    <TextField
      fullWidth
      placeholder={t('addPartModal.searchPlaceholder')}
      value={value}
      onChange={e => onChange(e.target.value)}
      sx={{ mb: 1 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        )
      }}
    />
  );
};
